import { Content } from "@/components/General/Overlay/components/content";
import { Base } from "@/components/General/Overlay/overlay.base";
import { Portal } from "@/components/General/Portal/portal";

export const Overlay = Object.assign(Base, {
    Portal: Portal,
    Content: Content
});
